module.exports = __webpack_public_path__ + "img/ueber-mich-2_1280.cb59ac3d.jpg";